import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  CircularProgress,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  ExperimentDialogHeader,
  ExperimentBasicInfoSection,
  ExperimentTimelineSection,
  ExperimentConfigurationSection,
  ExperimentTreatmentsTable,
} from './ExperimentDetailsDialogComponents';
import { formatTrafficAllocation } from './ExperimentDetailsDialogComponents/utils';

const ExperimentDetailsDialog = ({
  open,
  onClose,
  experiment,
  onStatusChange,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: theme.palette.background.default,
          borderRadius: '12px',
          boxShadow: 'none',
          border: `1px solid ${theme.palette.divider}`,
        },
      }}
    >
      {!experiment ? (
        <DialogContent
          sx={{
            p: 4,
            textAlign: 'center',
            backgroundColor: theme.palette.background.default,
            minHeight: '200px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress
            size={40}
            sx={{
              mb: 2,
              color: theme.palette.primary.main,
            }}
          />
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.secondary,
              fontSize: '0.875rem',
            }}
          >
            Loading experiment details...
          </Typography>
        </DialogContent>
      ) : (
        <>
          <ExperimentDialogHeader
            experiment={experiment}
            onClose={onClose}
            onStatusChange={onStatusChange}
          />

          <DialogContent
            sx={{
              p: 1.5,
              backgroundColor: theme.palette.background.default,
              '&.MuiDialogContent-root': {
                paddingTop: 1.5,
              },
            }}
          >
            <Grid container spacing={0.75}>
              <ExperimentBasicInfoSection experiment={experiment} />
              <ExperimentTimelineSection experiment={experiment} />
              <ExperimentConfigurationSection
                experiment={experiment}
                formatTrafficAllocation={formatTrafficAllocation}
              />
              <ExperimentTreatmentsTable experiment={experiment} />
            </Grid>
          </DialogContent>

          <DialogActions
            sx={{
              p: 2.5,
              pt: 2,
              backgroundColor: theme.palette.background.paper,
              borderTop: `1px solid ${theme.palette.divider}`,
              justifyContent: 'flex-end',
            }}
          >
            <Button
              onClick={onClose}
              sx={{
                color: theme.palette.primary.main,
                textTransform: 'none',
                fontSize: '0.875rem',
                fontWeight: 500,
                px: 2,
                py: 0.75,
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
            >
              Close
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default ExperimentDetailsDialog;
